import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f408974"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-5xl mb-8" }, "Welcome to GPT Craft"),
  /*#__PURE__*/_createElementVNode("p", null, "A database of prompts for GPT and an easy-to-use form builder to create custom prompts and generate text based on your specific needs.")
], -1))
const _hoisted_3 = { class: "w-full flex" }
const _hoisted_4 = { class: "mx-auto flex flex-col lg:flex-row lg:p-4 main-block" }
const _hoisted_5 = { class: "container mx-auto lg:pt-4 flex-center w-full" }
const _hoisted_6 = { class: "main-body" }
const _hoisted_7 = { class: "tabs text-lg flex text-center mt-4 mb-4" }
const _hoisted_8 = { class: "section w-full" }
const _hoisted_9 = { class: "container mx-auto pt-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "text-3xl" }, "Playground:")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_Categories = _resolveComponent("Categories")!
  const _component_Prompts = _resolveComponent("Prompts")!
  const _component_Playground = _resolveComponent("Playground")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TheHeader),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Categories),
        _createElementVNode("main", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab w-1/2 cursor-pointer py-2 text-lg", {active: _ctx.tab === 'search' || !_ctx.tab}]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tab = ''))
              }, "All", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["tab w-1/2 cursor-pointer py-2 text-lg", {active: _ctx.tab === 'my'}]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = 'my'))
              }, "Favorites", 2),
              (_ctx.user)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["tab w-1/2 cursor-pointer py-2 text-lg", {active: _ctx.tab === 'own'}]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tab = 'own'))
                  }, "My", 2))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_Prompts, { tab: _ctx.tab }, null, 8, ["tab"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_Playground, {
          class: "w-full",
          id: "playground"
        })
      ])
    ])
  ]))
}